import React from 'react';
import { WrappedFieldProps } from 'redux-form';

import { SFormTextField } from 'components/styled';

interface TextFieldProps extends WrappedFieldProps {
  inputRef?: (ref: HTMLInputElement) => void;
}

const TextFieldReduxWrapper = ({
  input,
  meta: { touched, error },
  inputRef,
  ...restProps
}: TextFieldProps) => (
  <SFormTextField
    {...input}
    {...restProps}
    ref={inputRef}
    error={touched ? error : undefined}
  />
);

export default TextFieldReduxWrapper;
